import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as moment from "moment";
import 'moment/locale/it';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { messagefromComponent } from '../../../class/appinterface';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { GetFilterService } from '../../../services/get-filter.service';
import { ModelliStampaService } from '../../../services/modelli-stampa.service';
import { UtilityService } from '../../../services/utility.service';
import { IPartner } from '../../../views/crm/interfaces';
import { NicaInfoAnagraficaAziendaComponent } from '../../anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { NicaAnagraficaComponent, ToolbarButton } from '../../nica-anagrafica/nica-anagrafica.component';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { Contatto } from './interfaces';
import { resolve } from 'url';
import { event } from 'jquery';
moment.locale('it')

const OperatoriFiltro = {
  contains: "contiene",
  notcontains: "non contiene",
  startswith: "inizia con",
  endswith: "termina con",
  "<>": "diverso",
  "=": "uguale",
};

const KeyFiltro = {
  CodAss: "Codice Ass",
  RagSoc: "Ragione Sociale",
  Ind: "Indirizzo",
  civico: "Civico",
  cap: "Cap",
  PIva: "Partita Iva",
  Cf: 'Codice Fiscale'
}

interface ObjEstrattoConto {
  COD: number
  CODTESTATA: number
  TIPRIGA: string
  CONTO: string
  CODIVA: string
  ALIQIVA: string
  IMPORTO: number
  SEGNO: string
  IMPO2: number
  NOTA: string
  RIFER: string
  CCR: string
  C1: string
  C2: string
  C3: string
  C4: string
  C5: string
  VER: string
  ID: string
  IDT: string
  BLOK: string
  IMPORT: string
  PnTestata: PnTestata[]
}

interface PnTestata {
  COD: number
  CAUS: string
  TIPCAUS: string
  DATAREG: string
  DATADOC: string
  DTUK: string
  SERIE: string
  NUMDOC: string
  NOTA: string
  CLIFOR: string
  IVASOSP: string
  RGA: string
  RGV: string
  PROTA: string
  PROTV: string
  RGC: string
  GIADIF: string
  STPA: string
  STPV: string
  STPC: string
  STPG: string
  TOTDOC: number
  TOTESENTE: number
  TOTIMPON: number
  TOTIMPOSTA: number
  CONTRATTO: string
  CLICONTR: string
  CONDIZPAG: string
  C1: string
  C2: string
  C3: string
  C4: string
  C5: string
  C6: string
  C7: string
  C8: string
  C9: string
  VER: string
  ID: string
  IDT: string
  BLOK: string
  IMPORT: string
}


@Component({
  selector: 'app-crm-contatti',
  templateUrl: './crm-contatti.component.html',
  styleUrls: ['./crm-contatti.component.css']
})
export class CrmContattiComponent implements OnInit, AfterViewInit {
  @ViewChild('anagraficaContatti', { static: false }) anagraficaContatti!: NicaAnagraficaComponent;
  @ViewChild('crmContattiForm', { static: false }) crmContattiForm!: NewNicaFormComponent;
  @Input() titolo: string = '';
  codRow: number;

  public partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  };
  private $distruggi: Subject<void> = new Subject<void>()
  private dataFinale = []
  selectedDataAna
  dataTagStat = []
  dataTagComme = []
  dataTagEcon = []
  dataAgente = []
  dataTipoContatti = []
  dataTagStatoProcedura = []
  dataTagModulo = []
  dataTipoRuolo = []
  selectedTagStat = []
  selectedAttivita = []
  selectedTagComme = []
  selectedTagEcon = []
  selectedTipoContatto = []
  selectedTagStatoProcedura = []
  selectedTagModulo = []
  selectedAgente = ''
  tipoRuolo = []
  province = []

  listRegione = []
  listProvince = []
  listComune = []

  stCliente = []
  statoCommerciale = [
    { key: 0, label: 'Offerta accettata' },
    { key: 1, label: 'Offerta non accettata' },
    { key: 2, label: 'Ordine ricevuto' },
    { key: 3, label: 'Ordine non ricevuto' }
  ]

  dataTipoAttivita = [
    { id: 0, descrizione: 'Produttore' },
    { id: 1, descrizione: 'Smaltitore' },
    { id: 2, descrizione: 'Intermediario' },
    { id: 3, descrizione: 'Trasportatore' },
    { id: 4, descrizione: 'Consulente' }
  ]

  tpContratto = []
  statoContratto = []


  selec
  queryTagStat = ''
  queryTagComme = ''
  queryStCliente = ''
  queryTagEcon = ''
  queryTagContatto = ''
  queryStatoProcedura = ''
  queryTagModulo = ''
  queryTagAgente = ''
  titoloGriglia: string = `
  <span class="informer pe-3" style="font-size: 21px">
            <span role="status">Totale Contatti: 0</span>
        </span>
  `


  isEdit = false
  isInsert = false
  detailSelectedRow: { [key: string]: any } = {}
  contactOptions = [
    { id: 0, descrizione: 'Sospeso' },
    { id: 1, descrizione: 'Attivo' },
    { id: 2, descrizione: 'Ex Cliente' },
    { id: 4, descrizione: 'Ex Cliente con Agente' },
    { id: 3, descrizione: 'Altro' },
  ];

  readonly statoProcedura: any[] = [
    { key: 0, label: 'Disattivo' },
    { key: 1, label: 'Attivo' },
    { key: 3, label: 'Disdetta' }
  ];

  readonly tipoVettore: any[] = [
    { id: 1, descrizione: 'Vettore Terrestre' },
    { id: 2, descrizione: 'Terminalista' },
    { id: 3, descrizione: 'Gestore Ferroviario' },
    { id: 4, descrizione: 'Gestore Marittimo' },
  ]
  selectedContactType = []
  selectedStatoProcedura: string = '';
  selectedTipoVettore: string = '';
  filtroCodAss: string = '';
  escludiProcedura: boolean = false;
  escludiModulo: boolean = false;
  disableEscludiProcedura: boolean = true;
  enableTipoVettore: boolean = true;
  disableEscludiModulo: boolean = true;
  myFilter: string = '';
  masterDetail
  calcolaAttivita: boolean = false
  showFilterExcel: Array<Record<string, string>> = [];
  includeFilterExcel: Array<Record<string, string>> = [];
  dataCensimento: any[] = [];
  private filtroTimer: any;
  private destroy$ = new Subject<void>();
  selectedRegione: any = null;
  selectedProvincia: any = null;
  selectedComune: any = null;
  contattoSelezionato: Contatto;
  showRecapiti: boolean = false

  selectedStClient: any = null
  selectedStatoCommerciale: any = null
  selectedTpContratto: any = null
  selectedStatoContratto: any = null


  exportEmail: ToolbarButton[] = [
    {
      location: 'after',
      widget: 'dxButton',
      cssClass: '',
      options: {
        icon: 'email',
        title: 'Esporta Email',
        stylingMode: 'text',
        id: 'exportEmailBtn',
        text: 'Esporta Email',
        class: '',
        index: 1,
      }
    },
  ]
  hideEmotion: boolean;
  //!------------------------------------------------------------------------------------------------------------------------------
  constructor(
    private userComponentService: ComponentService,
    private api: Apiservice,
    private anagraficaService: AnagraficaService,
    private spinner: NgxSpinnerService,
    private getFilter: GetFilterService,
    private cdr: ChangeDetectorRef,
    private utilityService: UtilityService,
    private stampaPdfService: ModelliStampaService,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void {
    this.getFilter.subject.pipe(takeUntil(this.$distruggi)).subscribe({
      next: (filtri) => {
        console.log('FILTRI IN ARRIVO ', filtri)
        let parsedFilters: any;

        try {
          parsedFilters = typeof filtri === 'string' ? JSON.parse(filtri) : filtri;
        } catch (e) {
          console.error('Errore nel parsing dei filtri JSON:', filtri, e);
          return;
        }

        if (!Array.isArray(parsedFilters) || parsedFilters.length === 0) {
          console.warn('Nessun filtro applicato o formato non valido:', parsedFilters);
          return;
        }

        const risultato = this.costruisciFiltriAvanzati(parsedFilters);
        this.includeFilterExcel = [...this.showFilterExcel, ...risultato]
        console.log('stampo la fusione', this.includeFilterExcel)
        console.log('Filtri trasformati:', risultato);
      },
      error: (errore) => {
        return console.error(errore)
      },
      complete: () => { }
    })

    this.userComponentService.eventoToolbarObs$
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        switch (event) {
          case 'inviaCensimento':
            this.openCensimento()
            break;
        }
      });

    this.getApi('tabella?tipo=2').then((x) => {
      this.dataTagComme = x
    })
    this.getApi('tabella?tipo=3').then((x) => {
      this.dataTagEcon = x
    })
    this.getApi('tabella?tipo=24').then((x) => {
      this.dataTipoContatti = x
    })
    this.getApi('tabella?tipo=1').then((x) => {
      this.dataTagStat = x
    })
    this.getApi('agenti').then((x) => {
      this.dataAgente = x
      console.log('stampo dataAgen', this.dataAgente)
    })
    this.getApi('tabella?tipo=8').then((x) => {
      this.dataTipoRuolo = x
    })
    this.getApi('procedure?isModulo=0').then((x) => {
      this.dataTagStatoProcedura = x
    })
    this.getApi('procedure?isModulo=1').then((x) => {
      this.dataTagModulo = x
    })
    this.getApi('regioni').then((x) => {
      this.listRegione = x
    })

    this.getApi('tabella?tipo=200').then((x) => {
      this.stCliente = x
    })

    this.getApi('tabella?tipo=201').then((x) => {
      this.tpContratto = x
    })

    this.getApi('tabella?tipo=202').then((x) => {
      this.statoContratto = x
    })

    this.masterDetail = [
      {
        name: 'masterDetail',
        key: this.detailSelectedRow.Cod,
        titolo: 'Dettaglio Carichi',
        type: 'customComponent',
        configComponent: {
          componentName: 'CrmMasterDetailContattiComponent',
          idComponent: 'CrmMasterDetailContattiComponent',
          masterKey: 'Cod',
          queryString: '/[Cod]',
          dataSourceKey: 'dataRelated',
          partnerData: this.partnerData
        },
      }
    ]
  }

  private costruisciFiltriAvanzati(raw: any): { campo_filtro: string; tipo_filtro: string; valore_filtro: any }[] {
    let rawFilters: any;

    try {
      rawFilters = typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (e) {
      console.error('Errore nel parsing JSON:', raw, e);
      return [];
    }

    const filtroArray: { campo_filtro: string; tipo_filtro: string; valore_filtro: any }[] = [];

    const estraiFiltri = (element: any): void => {
      if (Array.isArray(element)) {
        if (element.length === 3 && typeof element[0] === 'string') {
          const [campo, tipo, valore] = element;
          const tipoStandard = OperatoriFiltro[tipo] !== undefined ? OperatoriFiltro[tipo] : tipo;
          const dataField = KeyFiltro[campo] !== undefined ? KeyFiltro[campo] : campo;
          filtroArray.push({
            campo_filtro: dataField,
            tipo_filtro: tipoStandard,
            valore_filtro: valore
          });
        } else {
          for (const item of element) {
            estraiFiltri(item);
          }
        }
      } else if (
        element &&
        typeof element === 'object' &&
        'campo_filtro' in element &&
        'tipo_filtro' in element &&
        'valore_filtro' in element
      ) {
        const tipoStandard = OperatoriFiltro[element.tipo_filtro] !== undefined
          ? OperatoriFiltro[element.tipo_filtro]
          : element.tipo_filtro;
        const dataField = KeyFiltro[element.campo_filtro] !== undefined
          ? KeyFiltro[element.campo_filtro]
          : element.campo_filtro;

        filtroArray.push({
          campo_filtro: dataField,
          tipo_filtro: tipoStandard,
          valore_filtro: element.valore_filtro
        });
      }
    };
    estraiFiltri(rawFilters);
    return filtroArray;
  }

  ngAfterViewInit() {
    this.userComponentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe({
      next: (msg: messagefromComponent) => {
        return this.processaMsg(msg)
      },
      error: (errore) => {
        return console.error(errore)
      },
      complete: () => { }
    })
  }

  processaMsg(msg: messagefromComponent) {
    if (msg.destComponent !== this.constructor.name) {
      return
    }
    console.log('', msg)
    switch (msg.traceMessage) {
      case 'expandRow':
        console.log(msg.Data.Items[0].Cod)
        this.anagraficaContatti.selezionaRiga(msg.Data.Items[0].Cod)
        this.anagraficaContatti.griglia.instance.expandRow(msg.Data.Items[0].Cod)
        this.newCreaQuery()
        return
      default:
        return
    }
  }

  updateFilterExcel(nomeFiltro: string, event: any): void {
    if (event.addedItems && event.addedItems.length > 0) {
      const nuoveVoci = event.addedItems.map(i => i.descrizione !== undefined ? i.descrizione : i.Des);
      const index = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeFiltro);
      if (index !== -1) {
        const valoriCorrenti = this.showFilterExcel[index].valore_filtro.split(',').map(v => v.trim());
        const unione = Array.from(new Set([...valoriCorrenti, ...nuoveVoci]));
        this.showFilterExcel[index].valore_filtro = unione.join(', ');
      } else {
        this.showFilterExcel.push({
          campo_filtro: nomeFiltro,
          valore_filtro: nuoveVoci.join(', ')
        });
      }
    }

    if (event.selectedItem) {
      const index = this.showFilterExcel.findIndex(i => i.campo_filtro === nomeFiltro);
      const value = event.selectedItem.label !== undefined
        ? event.selectedItem.label
        : event.selectedItem.descrizione !== undefined
          ? event.selectedItem.descrizione
          : event.selectedItem.nome !== undefined ? event.selectedItem.nome : event.selectedItem.RagSoc1

      if (index !== -1) {
        this.showFilterExcel[index].valore_filtro = value;
      } else {
        this.showFilterExcel.push({
          campo_filtro: nomeFiltro,
          valore_filtro: value
        });
      }
    } else if (event.selectedItem === null) {
      const index = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeFiltro)
      this.showFilterExcel.splice(index, 1);
    }


    if (event.removedItems && event.removedItems.length > 0) {
      const daRimuovere = event.removedItems.map(i => i.descrizione !== undefined ? i.descrizione : i.Des);
      const index = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeFiltro);
      if (index !== -1) {
        const valoriCorrenti = this.showFilterExcel[index].valore_filtro.split(',').map(v => v.trim());
        const aggiornati = valoriCorrenti.filter(v => !daRimuovere.includes(v));
        if (aggiornati.length > 0) {
          this.showFilterExcel[index].valore_filtro = aggiornati.join(', ');
        } else {
          this.showFilterExcel.splice(index, 1);
        }
      }
    }
    console.table(this.showFilterExcel);
  }

  onOptionChanged(nomeColonna: string, nomeFiltro: string, event: any): void {
    const nome = nomeFiltro === 'Procedure' ? 'Procedura' : 'Modulo'
    if (event.value && nomeFiltro.trim() !== '') {
      const index = this.showFilterExcel.findIndex(i => i.campo_filtro === nomeColonna);
      if (nomeFiltro === 'Procedure' || nomeFiltro === 'Moduli') {
        const i = this.showFilterExcel.findIndex(f => f.campo_filtro === nome);

        if (i !== -1) {
          const filtroEsistente = this.showFilterExcel[i];
          const filtroRiorganizzato = {
            campo_filtro: filtroEsistente.campo_filtro,
            tipo_filtro: 'escluso',
            valore_filtro: filtroEsistente.valore_filtro
          };
          this.showFilterExcel[i] = filtroRiorganizzato;
          return
        }
      }


      if (index !== -1) {
        const valoriCorrenti = this.showFilterExcel[index].valore_filtro.split(',').map(v => v.trim());
        const unione = Array.from(new Set([...valoriCorrenti, nomeFiltro]));
        this.showFilterExcel[index].valore_filtro = unione.join(', ');
      } else {
        this.showFilterExcel.push({
          campo_filtro: nomeColonna,
          valore_filtro: nomeFiltro
        });
      }
    } else {
      const index = this.showFilterExcel.findIndex(f => f.valore_filtro.includes(nomeFiltro))

      if (nomeFiltro === 'Procedure' || nomeFiltro === 'Moduli') {
        const i = this.showFilterExcel.findIndex(f => f.campo_filtro === nome);
        if (i !== -1) {
          const filtroEsistente = this.showFilterExcel[i];
          const filtroRiorganizzato = {
            campo_filtro: filtroEsistente.campo_filtro,
            tipo_filtro: '',
            valore_filtro: filtroEsistente.valore_filtro
          };
          this.showFilterExcel[i] = filtroRiorganizzato;
          return
        }
      }
      if (index !== -1) {
        const valoriCorrenti = this.showFilterExcel[index].valore_filtro.split(',').map(v => v.trim()).filter(i => i !== nomeFiltro);
        this.showFilterExcel[index].valore_filtro = valoriCorrenti.join(', ');
        if (this.showFilterExcel[index].valore_filtro === '') {
          const indexColonna = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeColonna)
          this.showFilterExcel.splice(indexColonna, 1);
        }
      }
    }
    console.table(this.showFilterExcel);
  }

  applyFilterCodAss(nomeFiltro, value) {
    if (value !== '') {
      const index = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeFiltro);
      if (index !== -1) {
        this.showFilterExcel.splice(index, 1);
      }
      this.showFilterExcel.push({
        campo_filtro: nomeFiltro,
        valore_filtro: value
      });

    } else if (this.showFilterExcel.findIndex(f => f.campo_filtro.includes(nomeFiltro))) {
      const indexColonna = this.showFilterExcel.findIndex(f => f.campo_filtro === nomeFiltro)
      this.showFilterExcel.splice(indexColonna, 1);
    }
    console.table(this.showFilterExcel);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
  }

  async getApi(api: string) {
    return this.api.GetApiRest(api).then((x: { [key: string]: any }) => {
      return x.data
    }).catch((errore) => {
      console.error(errore)
      return []
    })
  }
  onValueChanged(event) {
    console.log(event)
    const id: string = event.element.id
    const value: number[] = event.value
    switch (id) {
      case 'tagStat':
        this.selectedTagStat = value
        this.queryTagStat = this.processFiltriTag(value, id)
        break
      case 'stCliente':
        this.selectedContactType = value
        if (this.selectedContactType.length !== 0) {
          this.selectedStatoProcedura = ''
          this.filtroCodAss = '';
        }
        this.queryStCliente = this.processFiltriTag(value, id)
        break
      case 'tipoAttivita':
        this.enableTipoVettore = !value.some((i) => i == 3)
        if (this.enableTipoVettore) this.selectedTipoVettore = null;
        this.selectedAttivita = value
        break;
      case 'tagEcon':
        this.selectedTagEcon = value
        this.queryTagEcon = this.processFiltriTag(value, id)
        break
      case 'tagComme':
        this.selectedTagComme = value
        this.queryTagComme = this.processFiltriTag(value, id)
        break
      case 'tagContatto':
        this.selectedTipoContatto = value
        this.queryTagContatto = this.processFiltriTag(value, id)
        break
      case 'tagProcedura':
        this.disableEscludiProcedura = (value.length > 0) ? false : true
        this.escludiProcedura = (this.disableEscludiProcedura) ? null : this.escludiProcedura
        this.selectedTagStatoProcedura = value
        this.queryStatoProcedura = this.processFiltriTag(value, id)
        break;
      case 'tagModulo':
        this.disableEscludiModulo = (value.length > 0) ? false : true
        this.escludiModulo = (this.disableEscludiModulo) ? null : this.escludiModulo
        this.selectedTagModulo = value
        this.queryTagModulo = this.processFiltriTag(value, id)
        break;
      case 'tagAgente':
        this.selectedAgente = event.value
        break;
      default:
        break
    }
    clearTimeout(this.filtroTimer);
    this.filtroTimer = setTimeout(() => {
      //this.creaQuery('filtroTag')
    }, 500)
  }
  onClick(event) {
    const id: string = event.element.id
    if (id === 'resetAllBtn') {
      this.selectedTagStat = []
      this.selectedAttivita = []
      this.selectedTagComme = []
      this.selectedTagEcon = []
      this.selectedTipoContatto = []
      this.selectedTagStatoProcedura = []
      this.selectedTagModulo = []
      this.selectedAgente = null
      this.queryTagStat = ''
      this.queryTagComme = ''
      this.queryStCliente = ''
      this.queryTagEcon = ''
      this.queryTagContatto = ''
      this.queryStatoProcedura = ''
      this.queryTagModulo = ''
      this.myFilter = ''
      this.selectedContactType = []
      this.selectedStatoProcedura = '';
      this.selectedTipoVettore = '';
      this.filtroCodAss = '';
      this.escludiProcedura = null;
      this.escludiModulo = null;


      this.selectedRegione = null;
      this.selectedProvincia = null;
      this.selectedComune = null;
      this.listProvince = [];
      this.listComune = [];

      this.selectedStClient = null;
      this.selectedStatoCommerciale = null;
      this.selectedTpContratto = null;
      this.selectedStatoContratto = null;
      this.includeFilterExcel = []
      this.showFilterExcel = []
      this.getFilter.setFilterColumn(null)



      this.anagraficaContatti.griglia.instance.clearFilter();
      this.newCreaQuery()
      this.cdr.detectChanges();
    }
  }
  castaMessage() {
    this.userComponentService.emitMessage({
      codeMessage: 1,
      descrMessage: 'cancella Dynamic Tutti',
      traceMessage: 'cancellaDynamicTutti',
      destComponent: ''
    })
  }
  onContactTypeChange() {
    this.selectedStatoProcedura = ''
    this.filtroCodAss = '';
  }

  onStatoProceduraChange() {
    this.selectedContactType = [];
    this.filtroCodAss = '';
  }

  processFiltriTag(filtri: number[], tipo: string): string {
    return filtri.length ? `$${tipo}=${filtri.join(',')}` : '';
  }

  newCreaQuery() {
    this.spinner.show()
    if (this.showFilterExcel.length > 0) this.includeFilterExcel = [...this.showFilterExcel]

    const grigliaInstance = this.anagraficaContatti.griglia.instance;
    const isProduttore = this.selectedAttivita.some((i) => i == 0)
    const isSmaltitore = this.selectedAttivita.some((i) => i == 1)
    const isIntermediario = this.selectedAttivita.some((i) => i == 2)
    const isTrasportatore = this.selectedAttivita.some((i) => i == 3)
    const isConsulente = this.selectedAttivita.some((i) => i == 4)
    grigliaInstance.clearFilter();
    this.myFilter = '';

    this.selectedStatoProcedura = (this.selectedStatoProcedura == null) ? '' : this.selectedStatoProcedura
    this.selectedContactType = (this.selectedContactType.length === 0) ? [] : this.selectedContactType

    if (this.selectedStatoProcedura !== "" && (this.selectedContactType.length === 0 && this.filtroCodAss === '')) {
      this.myFilter = `?$tagProcedure=${this.selectedStatoProcedura}`;
    }

    if (this.selectedTipoVettore !== '' && this.selectedTipoVettore !== null) {
      this.myFilter += (this.myFilter !== '') ? `&tipoVettore=${this.selectedTipoVettore}` : `?tipoVettore=${this.selectedTipoVettore}`
    }

    if (this.selectedStatoCommerciale !== '' && this.selectedStatoCommerciale !== null) {
      this.myFilter += (this.myFilter !== '') ? `&statoCommerciale=${this.selectedStatoCommerciale}` : `?statoCommerciale=${this.selectedStatoCommerciale}`
    }

    if (this.filtroCodAss) {
      grigliaInstance.filter(['CodAss', 'contains', this.filtroCodAss]);
    }

    if (this.selectedAgente) {
      this.myFilter += (this.myFilter !== '') ? `&CodAgente=${this.selectedAgente}` : `?CodAgente=${this.selectedAgente}`
    }

    if (isTrasportatore) {
      this.myFilter += (this.myFilter !== '') ? `&is_trasportatore=1` : `?is_trasportatore=1`
    }
    if (isProduttore) {
      this.myFilter += (this.myFilter !== '') ? `&is_produttore=1` : `?is_produttore=1`
    }
    if (isSmaltitore) {
      this.myFilter += (this.myFilter !== '') ? `&is_smaltitore=1` : `?is_smaltitore=1`
    }
    if (isIntermediario) {
      this.myFilter += (this.myFilter !== '') ? `&is_intermediario=1` : `?is_intermediario=1`
    }
    if (isConsulente) {
      this.myFilter += (this.myFilter !== '') ? `&is_consulente=1` : `?is_consulente=1`
    }

    if (this.escludiProcedura) {
      this.myFilter += (this.myFilter !== '') ? `&$escludiProcedura=1` : `?$escludiProcedura=1`
    }

    if (this.escludiModulo) {
      this.myFilter += (this.myFilter !== '') ? `&$escludiModulo=1` : `?$escludiModulo=1`
    }

    if (this.selectedRegione !== '' && this.selectedRegione !== null) {
      if (!this.selectedProvincia && !this.selectedComune) {
        this.myFilter += (this.myFilter !== '') ? `&id_regione=${this.selectedRegione}` : `?id_regione=${this.selectedRegione}`
      }
    }

    if (this.selectedProvincia !== '' && this.selectedProvincia !== null) {
      if (!this.selectedComune) {
        this.myFilter += (this.myFilter !== '') ? `&id_provincia=${this.selectedProvincia}` : `?id_provincia=${this.selectedProvincia}`
      }
    }

    if (this.selectedComune !== '' && this.selectedComune !== null) {
      this.myFilter += (this.myFilter !== '') ? `&id_localita=${this.selectedComune}` : `?id_localita=${this.selectedComune}`
    }

    if (this.selectedStClient !== '' && this.selectedStClient !== null) {
      this.myFilter += (this.myFilter !== '') ? `&stCliente=${this.selectedStClient}` : `?stCliente=${this.selectedStClient}`
    }

    if (this.selectedTpContratto !== '' && this.selectedTpContratto !== null) {
      this.myFilter += (this.myFilter !== '') ? `&stTipologiaContratto=${this.selectedTpContratto}` : `?stTipologiaContratto=${this.selectedTpContratto}`
    }

    if (this.selectedStatoContratto !== '' && this.selectedStatoContratto !== null) {
      this.myFilter += (this.myFilter !== '') ? `&stStatoContratto=${this.selectedStatoContratto}` : `?stStatoContratto=${this.selectedStatoContratto}`
    }


    const query = [this.queryTagComme, this.queryTagEcon, this.queryTagStat, this.queryTagContatto, this.queryStatoProcedura, this.queryTagModulo, this.queryStCliente]
      .filter(tag => tag !== '')
      .join('&');

    if (query) {
      this.myFilter += this.myFilter !== '' ? `&${query}` : `?${query}`;
    }

    this.anagraficaContatti.refresh()
    setTimeout(() => {
      this.anagraficaContatti.griglia.instance.collapseAll(-1)
      this.spinner.hide()
    }, 2000)
  }


  onInputFilter() {
    this.selectedContactType = []
    this.selectedStatoProcedura = ''
  }

  onAllEventAnagrafica(event) {
    if (this.partnerData.isPartner) {
      if (event.name === "onCellPrepared" && event.component) {
        const buttonArrayHtml = event.component.getCellElement(event.rowIndex, 'buttonArray') as HTMLElement
        if (buttonArrayHtml) {
          const btnFiles = buttonArrayHtml.querySelector('.filesList')
          if (btnFiles) btnFiles.classList.add('d-none')
        }
      }
    }

    if (event.name === "onCellPrepared" && event.componentName === 'listContact') {
      if (event.dataField === 'tipoAttivita') {
        let tipoAttivita = [];
        if (event.data) {
          if (event.data.is_produttore == 1) {
            tipoAttivita.push(
              {
                class: 'badge produttore-bg me-1',
                value: 'P',
                hint: 'Produttore'
              }
            )
          }
          if (event.data.is_trasportatore == 1) {
            tipoAttivita.push(
              {
                class: 'badge trasportatore-bg me-1',
                value: 'T',
                hint: 'Trasportatore'
              }
            )
          }
          if (event.data.is_smaltitore == 1) {
            tipoAttivita.push(
              {
                class: 'badge destinatario-bg me-1',
                value: 'S',
                hint: 'Smaltitore'
              }
            )
          }
          if (event.data.is_intermediario == 1) {
            tipoAttivita.push(
              {
                class: 'badge intermediario-bg me-1',
                value: 'I',
                hint: 'Intermediario'
              },
            )
          }
          if (event.data.is_consulente == 1) {
            tipoAttivita.push(
              {
                class: 'badge consulente-bg me-1',
                value: 'C',
                hint: 'Consulente'
              },
            )
          }
          event.cellElement.innerHTML = tipoAttivita.map((item) => `<span class="${item.class}" title="${item.hint || ''}">${item.value}</span>`).join('');
        }
      }
      if (event.dataField === "statoCensimento") {
        if (event && event.data) {
          const statoCensimento = []
          const clienteNonAttivo = (event.data.stCliente === 0 || event.data.stCliente === 2) && event.data.stCliente !== '' && event.data.stCliente !== null;
          if (clienteNonAttivo) {
            statoCensimento.push({
              class: 'me-1',
              value: ``,
              hint: ``
            })
          }

          if (!clienteNonAttivo) {
            let text = event.data.censimentoInviato == 1 ? 'Inviato' : 'Da inviare'
            statoCensimento.push({
              class: 'me-1',
              value: text,
              hint: text
            })
          }
          event.cellElement.innerHTML = statoCensimento
            .map(i => `<span class="${i.class}" style="font-size: '12px'}" title="${i.hint || ''}">${i.value}</span>`)
            .join('');
        }
      }

      if (event.dataField === 'statoContatto') {
        if (event && event.data) {
          const stato = [];

          const exClienteConAgente = (event.data.stCliente === 4) && event.data.stCliente !== '' && event.data.stCliente !== null;
          const rosso = (event.data.stCliente === 0 || event.data.stCliente === 2) && event.data.stCliente !== '' && event.data.stCliente !== null;
          const arancione = event.data.stCliente === 1 && event.data.nrProcedureDisattivate > 0;
          const giallo = event.data.stCliente === 1 && event.data.statoCommerciale === 1;
          const blue = event.data.stCliente === 1 && event.data.statoCommerciale === 3;
          const altro = event.data.stCliente === 3

          if (exClienteConAgente) {
            stato.push(
              {
                class: 'me-1',
                value: `Ex Cliente con Agente`,
                hint: `Ex Cliente con Agente`
              }
            );
          }

          if (rosso) {
            stato.push(
              {
                class: 'me-1',
                value: event.data.stCliente === 0 ? '🔴' : `Ex Cliente`,
                hint: event.data.stCliente === 0 ? `Cliente sospeso` : ``
              }
            );
          }

          if (giallo) {
            stato.push({ class: 'me-1', value: '🟡', hint: 'Offerta non accettata' });
          }

          if (blue) {
            stato.push({ class: 'me-1', value: '🔵', hint: 'Ordine non ricevuto' });
          }

          if (arancione) {
            stato.push({ class: 'me-1', value: '🟣', hint: 'Procedure non attive presenti' });
          }

          if (altro) {
            stato.push({ class: 'me-1', value: 'Altro', hint: 'Altro' });
          }

          if (!rosso && !giallo && !arancione && !blue && !altro) {
            stato.push({ class: 'me-1', value: '🟢', hint: 'Cliente attivo' });
          }

          event.cellElement.innerHTML = stato
            .map(i => `<span class="${i.class}" style="font-size: ${(event.data.stCliente === 2 || event.data.stCliente === 3 || event.data.stCliente === 4) ? '12px' : '16px'}" title="${i.hint || ''}">${i.value}</span>`)
            .join('');

        }

      }

      if (event.dataField === "censimento") {
        if (event && event.data) {
          const showCensimento = []
          const clienteNonAttivo = (event.data.stCliente === 0 || event.data.stCliente === 2) && event.data.stCliente !== '' && event.data.stCliente !== null;

          if (clienteNonAttivo) event.cellElement.innerHTML = showCensimento
        }
      }
    }
    if (!event.type || event.type !== "DynamicComponent") {
      if (event && event.name === "onInitNewRow") {
        this.selectedDataAna = { Cod: '' }
        this.isInsert = true
        this.isEdit = false
      }
      if (event && event.name === "onEditorPrepared") {
        this.selectedDataAna = event.data
        this.isEdit = true
        this.isInsert = false
      }
    }
    if (event && event.name === "endLoad") {
      console.log(event)
      if (event.componentName == 'listContact' && !event.keyEspansa) {
        if (event.totalCount) {
          this.anagraficaContatti.changeTitoloGriglia(`<span class="informer pe-3" style="font-size: 21px">
            <span role="status">Totale Contatti: ${event.totalCount}</span>
        </span>`)
        }
        if (!event.totalCount && event.count === 0) {
          this.anagraficaContatti.changeTitoloGriglia(this.titoloGriglia)
        }
      }
    }
    if (event && event.name === "masterDetailInitilized") {
      if (event.masterComponent && event.masterComponent.data) {
        this.detailSelectedRow = event.masterComponent.data
      }
    }
    if (event && event.name === "onRowPrepared") {
      if (event.rowType === 'data') {
        const row = event.rowElement as HTMLTableRowElement
        if (event.data.Disabilitato === 1) {
          row.classList.add('text-danger');
          this.hideEmotion = true;
          row.classList.add('text-black');
        } else {
          this.hideEmotion = true;
          row.classList.add('text-success');
          row.classList.add('text-black');
        }
      }
    }
    if (event.name === "masterDetailOptionaButtonClick") {
    }
  }

  openCensimento() {
    const contattoSelezionato: Contatto = this.contattoSelezionato
    let guid = Math.random().toString().replace("0.", "")
    let titoloPopup = `Invio documento per il censimento a: ${contattoSelezionato.RagSoc}`
    const instanceData = {

      api_template: ``,
      api_rest: true,
      guidPopUp: guid,
      remoteOperation: false,
      filterEditor: `/`,
      filterList: "",
      formActionType: "edit",
      formType: "simple",
      idTabRif: [],
      isEdit: false,
      masterKey: 'id',
      queryFilter: [],
      service: "crmCensimento",
      standardBtnBottom: [22, 23],
      nCol: 2,

      dataJson: {
        "id": contattoSelezionato.Cod,
        "RagSoc": contattoSelezionato.RagSoc,
        "pecNica": 'nicainformatica@pec.it',
        "pecCliente": contattoSelezionato.Fax,
        "oggettoMail": "Richiesta di verifica e rettifica dei dati anagrafici in archivio.",
        "testoMail": `Gentile ${contattoSelezionato.RagSoc},

nell’ambito delle attività di censimento e aggiornamento anagrafico, Vi chiediamo cortesemente di verificare i dati attualmente presenti nei nostri sistemi e, qualora necessario, di procedere con le opportune rettifiche negli appositi campi dedicati.

L’accuratezza delle informazioni inserite è fondamentale per garantire la corretta gestione operativa e amministrativa.

Vi invitiamo pertanto a completare la revisione nel più breve tempo possibile.

Per qualsiasi necessità di supporto o chiarimento, restiamo a disposizione.

Cordiali saluti,
Nica s.r.l. Informatica Aziendale – Società con socio unico
          `,
      }
    }



    this.userComponentService.setNewPopUp(
      guid,
      'NewNicaFormComponent',
      false,
      '900',
      null,
      instanceData,
      false,
      true,
      titoloPopup,
      'top'
    );

    const sub = this.userComponentService.outputComponent
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (res) => {

        // Gestisco solo gli eventi relativi a questo popup
        if (res.guid && res.guid !== guid) {
          return;
        }

        if (res.name === "return" || res.name === "close") {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
          sub.unsubscribe();
        }

        if (res.name === "submitFormStatic") {
          let sendPec;
          try {
            const base64 = await this.generaStampaContratto(this.dataCensimento, 'base64String');
            if (!base64) {
              alert("Errore durante l'invio del censimento", 'Attenzione!');
              return;
            }

            let objCensimento = {
              indirizzoMittente: res.data.pecNica,
              password: res.data.password,
              indirizzoDestinatario: res.data.pecCliente,
              oggetto: res.data.oggettoMail,
              corpoEmail: res.data.testoMail,
              base64: base64,
              idContatto: contattoSelezionato.Cod
            };

            this.spinner.show();
            sendPec = await this.api.PostApiRest('inviaPec', objCensimento);
          } catch (err) {
            console.log('errore durante invio censimento', err);
            sendPec = { code: 1 }

          } finally {
            let status = sendPec.code == 0 ? 'success' : 'error'
            this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
            this.anagraficaContatti.refresh();
            this.spinner.hide();
            notify({
              message: sendPec.code == 0 ? 'Censimento inviato' : 'Errore durante l`invio del censimento',
              height: 45,
              width: 250,
              position: 'center center'

            }, status, 3000);
            sub.unsubscribe();
          }
        }
      });

  }

  async optionalButtonEvent(event) {
    if (event.name == "censimento") {
      try {
        this.spinner.show()
        const res: any = await this.api.GetApiRest(`contatti/${event.row.data.Cod}`)
        console.log('stampo event del contatto dopo la chiamata', res)
        let formData: any = [
          {
            ...event.row.data,
            ...res.data
          }
        ];

        let recapiti: any = [...res.data.listaRecapitiContatto];
        let sedi: any = [...res.data.listaSedi];
        formData = formData.map(item => {
          const newItem: { [key: string]: any } = {};
          for (const key in item) {
            newItem[`censimento_${key}`] = item[key];
          }
          return newItem;
        });

        recapiti = recapiti.map(item => {
          const newItem: { [key: string]: any } = {};
          for (const key in item) {
            newItem[`censimento_recapiti_${key}`] = item[key];
          }
          return newItem;
        });

        this.dataCensimento = [...formData, ...recapiti];
        this.contattoSelezionato = event.row.data
        this.showRecapiti = recapiti.length !== 0 ? true : false
        this.generaStampaContratto(this.dataCensimento, 'preview', [30]);
      } catch {
        alert('Errore durante l`elaborazione del censimento.', 'Attenzione!')
      } finally {
        setTimeout(() => {
          this.spinner.hide()
        }, 2000);
      }
    }
    if (event.name === 'ProcedureDetailContatto') {
      const titolo = `Dettagli Procedure - ${event.row.data.RagSoc}`
      let dataToSend = {
        titolo: 'Procedure Contatto',
        api: 'getmasterprocedure',
        service: 'CrmProcedureDetail',
        gridHeight: 700,
        ricerca: false,
        soloRicercaGlobale: true,
        modeEdit: 'nicaform',
        masterKey: 'id',
        filter: '/$',
        dataReleted: event.row.data,
        costantValues: [
          { key: 'CodContatto', value: event.row.data.Cod },
          { key: 'id_master_procedura', value: '0' },
          { key: 'procedura_attiva', value: 1 },
          { key: 'accettaModuli', value: 1 },
          { key: 'dataAttivazione', value: new Date() },
          { key: 'quantita', value: 1 },

        ],
        TextAddRowButton: 'Inserisci Procedura',
        modifica: true,
        elimina: true,
        aggiungi: true,
        dxocolumnchooser: false,
        queryString: `?CodContatto=${event.row.data.Cod}&id_master_procedura=0`,
        masterDetail: [
          {
            chiave: '',
            titolo: 'Procedure Contatto',
            api: 'getmasterprocedure',
            name: '',
            masterKey: 'id',
            filter: '/$',
            wingap: false,
            modeEdit: 'nicaform',
            TextAddRowButton: 'Inserisci Modulo',
            service: 'CrmProcedureMasterDetail',
            isAdvancedXlsExportAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            isExportPDFAvailable: false,
            columnHidingEnabled: true,
            costantValues: [
              { key: 'CodContatto', value: event.row.data.Cod },
              { key: 'accettaModuli', value: 0 },
              { key: 'dataAttivazione', value: new Date() },
              { key: 'quantita', value: 1 },

            ],
            componenName: '',
            path: '',
            queryString: '?CodContatto=[CodContatto]&id_master_procedura=[id]',
            modifica: true,
            rimuovi: true,
            aggiungi: true
          }
        ]
      }
      this.apriPopUp('CrmAssegnaProcedureComponent', dataToSend, titolo)
    }
    if (event.name === "filesList") {
      const titolo = `Lista File - ${event.row.data.RagSoc}`
      let dataToSend = {
        queryString: `?nomeTabella=CRM_CONTATTI&idTabella=${event.row.data.Cod}`,
        dataJson: {
          idTabella: event.row.data.Cod,
          nomeTabella: "CRM_CONTATTI"
        }
      }
      this.apriPopUp('CrmFilesListComponent', dataToSend, titolo)
    }
    if (event.name === 'sediContatto') {
      console.log(event)
      const idContatto = event.row.data.Cod
      const RagSoc = event.row.data.RagSoc
      const dataContatto = event.row.data
      const titolo = `Sedi Contatto - ${RagSoc}`
      let dataToSend = {
        titolo: 'Sedi Contatto',
        dataContatto: dataContatto,
        api: 'sede',
        service: 'crmContattiSedeGrid',
        TextAddRowButton: 'Aggiungi Sede',
        isExportPDFAvailable: false,
        isExportDocxAvailable: false,
        isExportExcelAvailable: false,
        modifica: true,
        aggiungi: true,
        elimina: !this.partnerData.isPartner,
        partnerData: this.partnerData,
        gridHeight: '600',
        filter: `?CodiceContatto=${idContatto}`,
        costantValues: [
          { key: 'CodiceContatto', value: idContatto },
          { key: 'RagSoc', value: RagSoc },
        ],
        chiaviDettagli: [
          {
            chiave: 'id',
            titolo: '',
            api: 'responsabilicontatti',
            type: 'table',
            name: 'string',
            wingap: false,
            modeEdit: "nicaform",
            service: 'crmElencoRecapitiContattoGrid',
            masterKey: 'Cod',
            costantValues: [
              { key: 'Contatto', value: idContatto },
              { key: 'Sede', value: '[Cod]' },
            ],
            filter: '',
            defaultFormDisabled: false,
            queryString: '?Sede=[Cod]',
            modifica: true,
            aggiungi: true,
            rimuovi: !this.partnerData.isPartner,
            TextAddRowButton: 'Aggiungi Recapito'
          }
        ]
      }
      this.apriPopUp('CrmSediContattoComponent', dataToSend, titolo)
    }


    if (event.name === 'sendMail') {
      console.log('sendMail', event);
      const codSelected: number = event.row.data.Cod;
      console.log(codSelected);

      this.api.GetApiRest(`responsabilicontatti?Contatto=${codSelected}`).then((contattiResponse: any) => {
        const contatti = contattiResponse.data;

        console.log('contatti', contatti)

        this.api.GetApiRest(`sede?CodiceContatto=${codSelected}`).then((sediResponse: any) => {
          const sedi = sediResponse.data;
          console.log('sedi', sedi)
          let groupedData = sedi.map((sede: any) => {
            const contattiAssociati = contatti.filter((contatto: any) => contatto.Sede === sede.Cod);
            console.log('stampo contattiAssociati', contattiAssociati)
            return {
              sede,
              contatti: contattiAssociati
            };
          });
          console.log('stampo groupedData', groupedData)
          const contattoConSedeZero = contatti.filter((contatto: any) => contatto.Sede === 0 && contatto.Mail && contatto.Mail.trim() !== '');
          console.log('stampo contattoConSedeZero', contattoConSedeZero)
          if (contattoConSedeZero && contattoConSedeZero.length > 0) {
            groupedData.unshift({
              sede: { "Cod": 0, "RagSoc": event.row.data.RagSoc },
              contatti: contattoConSedeZero,
            })

          }
          const filteredData = groupedData.filter(item =>
            item.sede &&
            item.contatti &&
            Array.isArray(item.contatti) &&
            item.contatti.length > 0
          );


          const datiConMailValide = filteredData.filter(item =>
            item.contatti.some(contatto => contatto.Mail && contatto.Mail.trim() !== '')
          );

          let dataToSend = {
            obj: datiConMailValide.length == 0 ? undefined : datiConMailValide,
            idContatto: codSelected
          };

          this.apriPopUp('CrmEmailEditorComponent', dataToSend, `Invia Email - ${event.row.data.RagSoc}`, '1600');
        }).catch((error) => {
          console.error('Errore nella chiamata sede:', error);
        });
      }).catch((error) => {
        console.error('Errore nella chiamata contatti:', error);
      });
    }



    if (event.name === "sendMessage") {


      const titolo = `MESSAGGI DI:  ${event.row.data.RagSoc} (${event.row.data.CodAss})`


      let dataToSend = {
        dataCod: event.row.data.Cod,
        dataCodAss: event.row.data.CodAss
      }

      if (dataToSend.dataCod !== undefined && dataToSend.dataCodAss !== undefined) {
        this.apriPopUp('CrmSendMessaggeComponent', dataToSend, titolo, '800')
      } else {
        alert("Non hai possibilità di creare la form", 'Attenzione')
      }
    }
    if (event.name === "showProcedure") {
      const titolo = `RIEPILOGO PROCEDURE DI:  ${event.row.data.RagSoc.toUpperCase()} ${event.row.data.CodAss !== null ? `(${event.row.data.CodAss})` : ''} `
      let dataToSend = {
        queryString: `/${event.row.data.Cod}`,
        dataRelated: event.row.data,
        isPopUp: true,
        heightDetail: "390",
        heightTree: "703",
      }
      let guid = Math.random().toString().replace("0.", "")
      if (dataToSend.queryString !== undefined && dataToSend.dataRelated !== undefined) {
        this.userComponentService.setNewPopUp(guid, 'CrmDettagliProcedureContattiComponent', null, '1500', null, dataToSend, false, true, titolo, 'top')
        const sub = this.userComponentService.outputComponent.subscribe((res) => {
          if (res.guid !== guid) return;

          if (res.name === 'closePopup' && res.guid === guid) {
            this.anagraficaContatti.refresh()
            sub.unsubscribe();
          }
        })
      } else {
        alert("Non è possibile visualizzare il riepilogo delle procedure.", 'Attenzione')
      }
    }
  }

  checkDuplicati(obj: any): boolean {
    let duplicati = false;

    if (Array.isArray(obj)) {
      const filteredArray = obj.filter((item) => item && typeof item === 'object' && 'id_tag' in item && item.id_tag !== null && item.id_tag !== undefined);

      if (filteredArray.length > 0) {
        const idTag = filteredArray.map((item) => item.id_tag);
        const idDuplicati = idTag.filter((value, index, self) => self.indexOf(value) !== index);
        if (idDuplicati.length > 0) {
          duplicati = true;
        }
      }
      for (const item of obj) {
        if (this.checkDuplicati(item)) {
        }
      }
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key of Object.keys(obj)) {
        if (this.checkDuplicati(obj[key])) {
          duplicati = true;
        }
      }
    }
    return duplicati;
  }

  async generaStampaContratto(data: any, option: 'download' | 'preview' | 'base64String', standardBtnBottom: Array<number> = []): Promise<any> {
    if (!data) {
      console.error('Dati non validi per la generazione del censimento');
      throw new Error('Dati non validi');
    }

    const pagineArrayBuffer: ArrayBuffer[] = [];

    try {
      const censimento_page_1: any = await this.api.GetApi('ModellodiStampa/GetByGUID/a73e5dff-890f-4301-b460-9f2733c2fa56');

      if (censimento_page_1) {
        pagineArrayBuffer[0] = await this.stampaPdfService.generaPDF(data, censimento_page_1, 'arraybuffer', false) as ArrayBuffer;
      }

      if (this.showRecapiti) {
        const censimento_page_2: any = await this.api.GetApi('ModellodiStampa/GetByGUID/48c69dfc-29f5-4a9e-9fc1-a9e9428a96d0');
        if (censimento_page_2) {
          pagineArrayBuffer[1] = await this.stampaPdfService.generaPDF(data, censimento_page_2, 'arraybuffer', false) as ArrayBuffer;
        }
      }

      if (pagineArrayBuffer.length === 0 || !pagineArrayBuffer[0] || (this.showRecapiti && !pagineArrayBuffer[1])) {
        throw new Error('Errore nella generazione delle pagine PDF');
      }

      const res = await this.stampaPdfService.mergePDFMultipli(pagineArrayBuffer, option, standardBtnBottom);
      console.log(res)
      if (typeof res === 'string') {
        return res;
      }

    } catch (error) {
      alert('Errore durante la generazione del censimento', 'Attenzione!')
      console.error('Errore durante la generazione del censimento:', error);
    }
  }

  async formbtnEvent(event) {
    if (event.name === 'btnPIva' || event.name === 'btnCf') {
      const eventValue = (event.name === 'btnPIva') ? event.data.PIva : event.data.Cf
      const messageAlert = (event.name === 'btnPIva') ? 'Inserire la partita iva' : 'Inserire il codice fiscale'
      if (eventValue == null) return alert(messageAlert, 'Attenzione!')
      const titolo = (event.name === 'btnPIva') ? `Dettaglio Partita Iva: - ${eventValue}` : `Dettaglio Codice Fiscale: - ${eventValue}`
      let dataToSend: any[] = [{
        dati: eventValue,
      }]
      const guid = this.openComponentInPopUP('NicaInfoAnagraficaAziendaComponent', dataToSend, undefined, '800', titolo, false, true);
      const sub = this.userComponentService.outputComponent.subscribe(currentOutput => {

        if (currentOutput.guid && currentOutput.guid !== guid) {
          return;
        }

        if (currentOutput.eventName == 'incollaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent' && NicaInfoAnagraficaAziendaComponent.isMsgPartitaIVA(currentOutput)) {

          // let desc = "?$filter=nome like '" + currentOutput['localita'] + "'";
          const localita = currentOutput['localita'].replace(/'/g, "''");
          let desc = `?$filter=nome like '${localita}'`;
          this.api.GetApiRest(`comuni${desc}`).then(ree => {

            if (ree['items']) {
              this.crmContattiForm.formRefreshInputData('id_localita', ree['items'][0]['id']);
              this.crmContattiForm.formRefreshInputData('id_provincia', ree['items'][0]['id_provincia']);
              this.crmContattiForm.formRefreshInputData('id_regione', ree['items'][0]['id_regione']);
            }
          })
          console.log('currentOutput', currentOutput)
          this.crmContattiForm.formRefreshInputData('RagSoc', currentOutput['ragione_Sociale'].replace(/\s*\(.*?\)\s*/g, ' '));
          this.crmContattiForm.formRefreshInputData('Ind', currentOutput['indirizzo']);
          this.crmContattiForm.formRefreshInputData('Cf', currentOutput['vat']);
          this.crmContattiForm.formRefreshInputData('PIva', currentOutput['tax']);
          this.crmContattiForm.formRefreshInputData('civico', currentOutput['civico']);
          this.crmContattiForm.formRefreshInputData('Cap', currentOutput['cap']);
          this.crmContattiForm.formRefreshInputData('Fax', currentOutput['pec']);
          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();
          sub.unsubscribe();
        }
        if (currentOutput.eventName == 'annullaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent') {
          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();
          sub.unsubscribe();
        }
      });
    }

    if (event.name === 'showProcedure') {

      const titolo = `RIEPILOGO PROCEDURE DI:  ${event.data.RagSoc.toUpperCase()} ${event.data.CodAss !== null ? `(${event.data.CodAss})` : ''} `
      let dataToSend = {
        queryString: `/${event.data.Cod}`,
        dataRelated: event.data,
        isPopUp: true,
        heightDetail: "390",
        heightTree: "703",
      }
      let guid = Math.random().toString().replace("0.", "")
      if (dataToSend.queryString !== undefined && dataToSend.dataRelated !== undefined) {
        this.userComponentService.setNewPopUp(guid, 'CrmDettagliProcedureContattiComponent', null, '1500', null, dataToSend, false, true, titolo, 'top')
        const sub = this.userComponentService.outputComponent.subscribe((res) => {
          if (res.guid && res.guid !== guid) return;

          if (res.name === 'closePopup' && res.guid === guid) {
            if (event.component.dataSet.stCliente !== 1) {
              sub.unsubscribe();
              return;
            }
            // this.crmContattiForm.getData()
            // setTimeout(() => {
            //   if (event.component.dataSet.stCliente === 1 && event.component.dataSet.nrProcedureDisattivate !== null) {
            //     let classcaption = []
            //     event.component.formDataService.forEach(element => {
            //       if (element.captionClass) {
            //         classcaption.push(element.captionClass)
            //       }
            //     });
            //     this.hideEmotion = true;
            //     classcaption.forEach((element, index) => {
            //       if (index === 0) {
            //         const caption: HTMLElement = $(`.${element}`)[0];

            //         if (caption) {
            //           const baseText = caption.textContent.replace(/\s*\(Procedure non attive:.*?\)/g, '').trim();

            //           const totaleProcedure =
            //             Number(event.component.dataSet.nrProcedureDisattivate) +
            //             Number(event.component.dataSet.nrProcedureAttive);

            //           const procedureDisattivate = Number(
            //             event.component.dataSet.nrProcedureDisattivate
            //           );

            //           caption.textContent = `${baseText} (Procedure non attive: ${procedureDisattivate} su ${totaleProcedure})`;

            //           caption.classList.remove('text-warning', 'text-danger');
            //         }

            //       }
            //     });
            //   }
            // }, 1000)
            sub.unsubscribe();
          }
        })
      } else {
        alert("Non è possibile visualizzare il riepilogo delle procedure.", 'Attenzione')
      }
    }

    if (event && event.name === 'beforSave') {
      if (event.formData.stCliente == null) event.formData.stCliente = 1
      const datiDuplicati = this.checkDuplicati(event.formData)
      if (datiDuplicati) {
        event.cancella = true;
        event.isValid = false
        alert('Duplicati presenti nella sezione dei tabs', 'Attenzione!')
      }
    }
    if (event.name === 'submittedEditOk') {
      console.log('submittedEditOk', event)

      this.isEdit = false
      this.isInsert = false
      setTimeout(() => {
        // this.navigateToRowByCod(this.codRow)
        this.newCreaQuery()
      }, 2000)
    }
    if (event.name === 'submittedInsertOk') {
      console.log('submittedInsertOk', event)
      this.isEdit = false
      this.isInsert = false
      setTimeout(() => {
        this.newCreaQuery()
        if (event.formData) {
          const contattoUltimo: Contatto = event.formData
          const titolo = `Sedi Contatto - ${contattoUltimo.RagSoc}`
          let dataToSend = {
            titolo: 'Sedi Contatto',
            dataContatto: contattoUltimo,
            api: 'sede',
            service: 'crmContattiSedeGrid',
            TextAddRowButton: 'Aggiungi Sede',
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            nuovoInserimento: true,
            modifica: true,
            aggiungi: true,
            elimina: !this.partnerData.isPartner,
            partnerData: this.partnerData,
            gridHeight: '600',
            filter: `?CodiceContatto=${contattoUltimo.Cod}`,
            costantValues: [
              { key: 'CodiceContatto', value: contattoUltimo.Cod },
              { key: 'RagSoc', value: contattoUltimo.RagSoc },
            ],
            chiaviDettagli: [
              {
                chiave: 'id',
                titolo: '',
                api: 'responsabilicontatti',
                type: 'table',
                name: 'string',
                wingap: false,
                modeEdit: "nicaform",
                service: 'crmElencoRecapitiContattoGrid',
                masterKey: 'Cod',
                costantValues: [
                  { key: 'Contatto', value: contattoUltimo.Cod },
                  { key: 'Sede', value: '[Cod]' },
                ],
                filter: '',
                defaultFormDisabled: false,
                queryString: '?Sede=[Cod]',
                modifica: true,
                aggiungi: true,
                rimuovi: !this.partnerData.isPartner,
                TextAddRowButton: 'Aggiungi Recapito'
              }
            ]
          }

          // this.navigateToRowByCod(event.formData.Cod)
          this.apriPopUp('CrmSediContattoComponent', dataToSend, titolo)
        }
      }, 2000)
    }
    if (event.event && event.event === "saveContatto") {
      setTimeout(() => {
        this.newCreaQuery()
      }, 1000)
      if (this.crmContattiForm) {
        this.crmContattiForm.onFormSubmit()
      }
    }
    if (event.event && event.event === "abbandona") {
      setTimeout(() => {
        this.newCreaQuery()
      }, 1000)
      if (this.crmContattiForm) {
        this.crmContattiForm.checkReturn()
      }
    }
    if (event.name === "return") {
      this.isEdit = false
      this.isInsert = false
      setTimeout(() => {
        // this.navigateToRowByCod(this.codRow)
        this.newCreaQuery()
      }, 2000)
    }
    if (event.name === "apriLink") {
      if (event.buttonEvent && event.buttonEvent.dataField) {
        if (event.data) {
          if (event.data[event.buttonEvent.dataField] && event.data[event.buttonEvent.dataField] !== null && event.data[event.buttonEvent.dataField] !== '') {
            let link = event.data[event.buttonEvent.dataField] as string
            this.userComponentService.apriLinkEsterno(link)
          } else {
            alert('Link non presente', 'Attenzione')
          }
        }
      }
    }
    if (event.name === "inviaEmailAgente") {
      if (event.data) {
        if (event.data['CodAgente'] && event.data['CodAgente'] !== null && event.data['CodAgente'] !== '') {
          this.api.GetApiRest(`agenti/${event.data['CodAgente']}`).then((resp: any) => {
            if (resp.data) {
              let obj = []
              if (resp.data.MailAzienda && resp.data.MailAzienda !== '') {
                const MailAzienda = resp.data.MailAzienda.split(';').map((value: string) => value.trim())
                obj.push({
                  sede: { Cod: 0, RagSoc: resp.data.RagSoc1 },
                  contatti: MailAzienda.map((value: string) => {
                    let guid = Math.random()
                    return {
                      Cod: guid,
                      Sede: 0,
                      Mail: value
                    }
                  })
                })
              }
              if (resp.data.Mail && resp.data.Mail !== '') {
                const Mail = resp.data.Mail.split(';').map((value: string) => value.trim())
                obj.push({
                  sede: { Cod: 1, Ind: resp.data.Resp },
                  contatti: Mail.map((value: string, i) => {
                    let guid = Math.random()
                    return {
                      Cod: guid,
                      Sede: 1,
                      Mail: value
                    }
                  })
                })

              }
              if (obj.length <= 0) {
                obj = undefined
              }
              const inputOggettoValue = `Contatto: ${event.data['RagSoc']}${event.data['CodAss'] ? ' - Codice: ' + event.data['CodAss'] : ''}`
              this.apriPopUp('CrmEmailEditorComponent', { obj: obj, inputOggettoValue: inputOggettoValue }, 'Invia Email', '1400')
            }
          }).catch((error) => {
            alert('Errore Agente', 'Attenzione')
          })
        } else {
          alert('Seleziona un Agente', 'Attenzione')
        }
      }
    }

    if (event.name === "stampaContratto") {
      const guid = Math.random().toString().replace('0.', '');
      const contattoUltimo: Contatto = event.data
      const instanceData = {
        api_template: ``,
        api_rest: true,
        guidPopUp: guid,
        remoteOperation: false,
        filterEditor: `/`,
        filterList: "",
        formActionType: "edit",
        formType: "simple",
        idTabRif: [],
        isEdit: false,
        masterKey: 'id',
        nCol: 2,
        id: contattoUltimo.Cod,
        contatto: contattoUltimo,
        queryFilter: [],
        service: "crmStampaContrattoForm",
        standardBtnBottom: [22, 23],

        dataJson: {
          "id": contattoUltimo.Cod,
          "codiceContratto": contattoUltimo.CodAss,
          "codiceContratto0": '',
          "codiceContratto1": '',
          "codiceContratto2": '',
          "codiceContratto3": '',
          "codiceContratto4": '',
          "codiceContratto5": '',
          "codiceContratto6": '',
          "RagSoc": contattoUltimo.RagSoc,
          "indSedeLegale": contattoUltimo.Ind,
          "provinciaSedeLegale": contattoUltimo.Prov,
          "locSedeLegale": contattoUltimo.Loc,
          "capSedeLegale": contattoUltimo.Cap,
          "pIva": contattoUltimo.PIva,
          "cPag": contattoUltimo.CPag,
          "banca": contattoUltimo.Banca,
          "abi": contattoUltimo.Abi,
          "cab": contattoUltimo.Cab,
          "cc": contattoUltimo.Cc,
          "cin": contattoUltimo.Cin,
        }
      }

      const titoloPopup = 'Dati del contratto';


      this.userComponentService.setNewPopUp(
        guid,
        'StampaContrattoComponent',
        false,
        '1500',
        null,
        instanceData,
        false,
        true,
        titoloPopup,
        'top'
      );
    }

    if (event.name === "estrattoConto") {
      this.spinner.show()
      let response: Response;
      try {
        let formatCodCli = ''
        if (!event.data.codCli.toUpperCase().includes('C')) {
          let codCli = '000000' + event.data.codCli
          formatCodCli = `C${codCli.slice(-6)}`
        } else {
          formatCodCli = event.data.codCli
        }
        response = await fetch(`https://192.168.10.110:3000/api/utenti?CLIFOR=${formatCodCli}`, {
          method: "GET",
          headers: {
            "Accept": "application/json",
          },
        });

        const obj: any[] = await response.json();

        let saldo: number = 0;

        const formatObj = obj.map(o => {
          const dare = o.segno === 'D' ? o.importo : null;
          const avere = o.segno === 'A' ? o.importo : null;
          saldo = saldo + (dare - avere);

          const saldoView =
            saldo === 0 ? '0.00'
              : saldo > 0 ? `${this.formatNumber(saldo)} D`
                : `${this.formatNumber((saldo * -1))} A`;

          return {
            NUMDOC: o.NUMDOC,
            DATAR: o.DATAREG,
            DATADOC: o.DATADOC,
            CAU: o.caus,
            dare: dare !== null ? this.formatNumber(dare) : null,
            avere: avere !== null ? this.formatNumber(avere) : null,
            saldo: saldoView,
            des: o.nota,
          };
        });

        var instanceData = {
          campoTabRif: '',
          masterKey: 'id',
          keyUnique: '',
          selectRow: 'none',
          rowAlternationEnabled: true,
          name: 'EstrattoConto',
          titolo: 'EstrattoConto',
          remoteOperations: false,
          allowUpdating: false,
          allowDeleting: false,
          allowAdding: false,
          searchAndSelect: false,
          searchType: 'contains',
          showColBlank: true,
          toolbarButtonsBottomLeft: null,
          toolbarButtonsBottomRight: [0],
          isOdata: false,
          gridHeight: 600,
          classe: 'p-3 rounded gridOfWidget',
          dxosorting: 'multiple',
          overrideDataSource: null,
          concatDataField: null,
          service: 'crmEstrattoConto',
          api: '',
          isStatic: true,
          myDsStatic: formatObj,
          isDataStatic: true,
          columnHidingEnabled: true,
          modifica: false,
          aggiungi: false,
          elimina: false,
          isExportDocxAvailable: false,
          isExportPDFAvailable: false,
          isExportExcelAvailable: false,
          showHeader: false,
          showFooter: false,
          dxocolumnchooser: false,
          ricerca: false,
          soloRicercaGlobale: false,
          allowColumnResizing: true,
        }
      } catch (err) {
        console.log(err)
        setTimeout(() => {
          alert("Errore durante il recupero dell'estratto conto.", "Attenzione!")
          this.spinner.hide()
        }, 1000)
      } finally {
        setTimeout(() => {
          if (response && response.ok) {
            const titoloPopup = `Estratto Conto - ${event.data.RagSoc}`;
            const guid = Math.random().toString().replace('0.', '');
            this.userComponentService.setNewPopUp(
              guid,
              'NicaAnagraficaComponent',
              false,
              '1300',
              null,
              instanceData,
              false,
              true,
              titoloPopup,
              'top'
            );
          }

          this.spinner.hide()
        }, 1000)
      }
    }
  }

  // navigateToRowByCod(cod: number): void {
  //   this.anagraficaContatti.selezionaRiga(cod)
  //   this.anagraficaContatti.griglia.instance.navigateToRow(cod)
  // }

  formatNumber(x) {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', useGrouping: true }).format(x)
  }

  formEventItems(e) {
    if (e.formData && e.formData.is_trasportatore && e.formData.is_trasportatore == 1) {
      e.masterComponent.itemOption('informazioniGenerali.tipoVettore', 'disabled', false);
    }

    if (e.name == 'onValueChanged') {
      if (e.campo.dataField == 'is_trasportatore') {
        e.masterComponent.itemOption('informazioniGenerali.tipoVettore', 'disabled', !e.value);
        if (e.value) {
          this.crmContattiForm.formRefreshInputData('tipoVettore', 1)
        } else {
          this.crmContattiForm.formRefreshInputData('tipoVettore', null)
        }
      }
    }
  }

  formInit(event) {

    if (event.component && this.isInsert) {
      event.component.itemOption('informazioniGenerali.btnEstrattoConto', 'disabled', true);
      event.component.itemOption('informazioniGenerali.btnStampaContratto', 'disabled', true);
      event.component.itemOption('informazioniGenerali.btnSmartKey', 'disabled', true);
      event.component.itemOption('informazioniGenerali.btnDettagliProcedura', 'disabled', true);
    }

    if (event.name === "formContentInitializzed") {
      console.log('formContentInitializzed', event)
      if (event.component && event.component.formDataService) {
        if (event.formData) {
          console.log('stampo il formdata', event.formData)
          this.codRow = event.formData.Cod
          if (event.formData.stCliente === 0 || event.formData.stCliente === 2 || event.formData.stCliente === 4) {
            let classcaption = []
            event.component.formDataService.forEach(element => {
              if (element.captionClass) {
                classcaption.push(element.captionClass)
              }
            });
            classcaption.forEach((element, index) => {
              if (index === 0) {
                let caption: HTMLElement = $(`.${element}`)[0];
                if (caption) {
                  let text = caption.innerHTML.split(' ').filter((x, index) => {
                    return !(x.includes('(') || x.includes(')'))
                  })
                  let errorText = event.formData.stCliente === 0 ? '(Cliente Sospeso)' : event.formData.stCliente === 2 ? '(Ex Cliente)' : '(Ex Cliente con Agente)'
                  caption.innerHTML = `${text.join(' ')} ${errorText}`
                  caption.classList.add('text-danger')
                  this.hideEmotion = false;
                }
              }
            });
          }
          // else if (event.formData.stCliente === 1 && event.formData.nrProcedureDisattivate !== null) {
          //   let classcaption = []
          //   event.component.formDataService.forEach(element => {
          //     if (element.captionClass) {
          //       classcaption.push(element.captionClass)
          //     }
          //   });
          //   this.hideEmotion = true;
          //   classcaption.forEach((element, index) => {
          //     if (index === 0) {
          //       let caption: HTMLElement = $(`.${element}`)[0];
          //       if (caption) {
          //         let text = caption.innerHTML.split(' ').filter((x, index) => {
          //           return !(x.includes('(') || x.includes(')'))
          //         })
          //         const totaleProcedure = parseInt(event.formData.nrProcedureDisattivate) + parseInt(event.formData.nrProcedureAttive)
          //         const procedureDisattivate = parseInt(event.formData.nrProcedureDisattivate)
          //         caption.innerHTML = `${text.join(' ')} (Procedure non attive: ${procedureDisattivate} su ${totaleProcedure})`
          //         caption.classList.remove('text-warning')
          //         caption.classList.remove('text-danger')
          //       }
          //     }
          //   });
          // }
        }
      }
    }

    if (this.partnerData.isPartner) {
      if (event.name === "formContentInitializzed") {
        const newNicaForm = event.component || undefined
        const elementRefs = newNicaForm.elementRef || undefined
        if (elementRefs !== undefined) {
          console.log('-----------------------------------------------------', event)
          const partnerExcludeTabs = ["CrmContattoExtra"];
          Object.entries(newNicaForm.innerTabs).forEach(([key, tab]: [string, { id: string, visible: boolean }]) => {
            if (partnerExcludeTabs.includes(tab.id)) {
              tab.visible = false;
            }
          });
          const partnerExcludeInput = ['CodAss', 'codCli', 'CodAgente']
          Object.keys(elementRefs).forEach(key => {
            if (partnerExcludeInput.some(ex => key.includes(ex))) {
              if (elementRefs[key].onInitialized !== null) {
                elementRefs[key].onInitialized.component.option('disabled', true)
              } else {
                elementRefs[key].htmlElement.disabled = true
              }
              elementRefs[key].editorComponent.showClearButton = false
              elementRefs[key].editorComponent.buttonTextArea = false
              if (elementRefs[key].editorComponent.buttonOption && elementRefs[key].editorComponent.buttonOption.length > 0) {
                elementRefs[key].editorComponent.buttonOption = []
              }
            }
            if (key === 'Disabilitato') {
              if (elementRefs[key].editorComponent.dataSetValue === 1) {
                elementRefs[key].editorComponent.isDisabled = true
                if (elementRefs[key].onInitialized !== null) {
                  elementRefs[key].onInitialized.component.option('disabled', true)
                } else {
                  elementRefs[key].htmlElement.disabled = true
                }
              }
            }
            if (key === 'CodAgente' && newNicaForm.isEdit === false) {
              newNicaForm.dataSet[key] = this.partnerData.id
            }

          });
        }
      }
    }
  }

  apriPopUp(componentname, dataToSend, titolo, width = '1600') {

    let guid = Math.random().toString().replace("0.", "")

    this.userComponentService.setNewPopUp(guid, componentname, null, width, null, dataToSend, false, true, titolo, 'top')
    // Nessuna subscribe qui: evitato accumulo di listener inutili
  }

  openComponentInPopUP(componentName: string, data: Array<any> = [], InstanceDatadata?, width: string = '', popupTitle?: string, showCaptionFooter: boolean = true, showCaptionHeader: boolean = true, position = 'center', help = '-') {

    let guid = Math.random().toString().replace("0.", "");
    if (data.length > 0) {
      data[0].currentTabId = guid
    }

    this.userComponentService.setNewPopUp(guid, componentName, data, width, null, InstanceDatadata, showCaptionFooter, showCaptionHeader, popupTitle, position, help)
    return guid
  }

  handleOptionButtonClick(event: number) {
    if (event == 1) {

      const instanceData = {
        api: ``,
        api_rest: true,
        remoteOperation: false,
        filterEditor: `/`,
        filterList: "",
        formActionType: "edit",
        formType: "simple",
        idTabRif: [],
        isEdit: false,
        masterKey: 'id',
        nCol: 2,
        queryFilter: [],
        service: "crmExportMailForm",
        widthForm: 600,
        standardBtnBottom: [22, 23],

      };

      const titoloPopup = 'Esporta Mail';
      const guid = Math.random().toString().replace('0.', '');

      this.userComponentService.setNewPopUp(
        guid,
        'NewNicaFormComponent',
        false,
        '600',
        null,
        instanceData,
        false,
        true,
        titoloPopup,
        'top'
      );

      const sub = this.userComponentService.outputComponent.subscribe((currentOutput) => {

        if (currentOutput.guid && currentOutput.guid !== guid) {
          return;
        }

        if (currentOutput.name === 'beforSave' && 'mailAziendale' in currentOutput.formData && currentOutput.guid === guid) {
          currentOutput.cancella = true;
          let mailAziendale: number = currentOutput.formData.mailAziendale;
          let ruoliSelezionati: Array<number> = currentOutput.formData.tipoRuolo;

          if (mailAziendale == 2 || mailAziendale == 3) {
            if (currentOutput.formData.tipoRuolo == null || currentOutput.formData.tipoRuolo.length == 0) {
              alert('Devi selezionare almeno un ruolo.', 'Attenzione!');
              return;
            }
          }

          let dataExport;
          const endpoint = (this.myFilter != '') ? `contatti${this.myFilter}` : 'contatti';
          const filterOperator = (this.myFilter != '') ? '&' : '?';
          const filterInColumn = this.getFilter.getFilter()
          const filterPart = filterInColumn.split('&').find(param => param.startsWith('$filter'));
          const finalEndpoint = filterPart ? `${endpoint}${filterOperator}${filterPart}` : endpoint

          this.api.GetApiRest(finalEndpoint).then((res: any) => {
            if (res.data.length == 0) return alert('Non ci sono dati da esportare', 'Attenzione!')
            dataExport = res.data;
            const workbook = new ExcelJS.Workbook();

            workbook.calcProperties.fullCalcOnLoad = true;
            workbook.views = [
              {
                x: 0, y: 0, width: 10000, height: 20000,
                firstSheet: 0, activeTab: 1, visibility: 'visible'
              }
            ]

            const contattiSheet = workbook.addWorksheet('export_contatti_anagrafica', {
              views: [{
                showGridLines: true
              }],
              headerFooter: {
                firstHeader: "Hello Exceljs",
                firstFooter: "Hello World"
              },
              pageSetup: {
                paperSize: 9,
                orientation: 'landscape'
              }
            });

            contattiSheet.state = 'visible';
            contattiSheet.properties.defaultColWidth = 100;


            switch (mailAziendale) {
              case 1:
                contattiSheet.columns = [
                  { header: 'Contatto', key: 'RagSocContatto', width: 50 },
                  { header: 'Indirizzo', key: 'Ind', width: 50 },
                  { header: 'E-mail', key: 'Mail', width: 50 }
                ];

                dataExport.forEach(item => {
                  if (item.Mail) {
                    const emails = item.Mail.split(';');
                    emails.forEach(email => {
                      if (email != '') {
                        contattiSheet.addRow({
                          RagSocContatto: item.RagSoc,
                          Ind: `${item.Ind} ${item.Prov ? `(${item.Prov})` : ''}`,
                          Mail: email.trim(),
                        });
                      }
                    });
                  }
                });

                const lastRow = contattiSheet.lastRow ? contattiSheet.lastRow.number : 1;
                contattiSheet.pageSetup.printArea = `A1:N${lastRow}`;

                workbook.xlsx.writeBuffer().then((buffer) => {
                  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  saveAs(blob, 'contatti_anagrafica.xlsx');
                  console.log('File Excel creato con successo!');

                  this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
                  this.userComponentService.destroyOutputComponent();
                  sub.unsubscribe();

                  notify({
                    message: 'Export avvenuto con successo',
                    height: 45,
                    width: 250,
                    position: 'center center'

                  }, 'success', 3000);
                }).catch(err => {
                  console.error('Errore durante la creazione del file Excel', err);
                });
                break;

              case 2:
              case 3:
                contattiSheet.columns = [
                  { header: 'Contatto', key: 'RagSocContatto', width: 50 },
                  { header: 'Sede', key: 'Ind', width: 50 },
                  { header: 'Ragione Sociale', key: 'RagSocRespContatto', width: 50 },
                  { header: 'E-mail', key: 'Mail', width: 50 },
                  { header: 'Tipo Contatto', key: 'tipo', width: 50 },
                ];
                this.api.GetApiRest(`sede`).then((sediResponse: any) => {
                  const sedi = sediResponse.data;

                  this.api.GetApiRest('responsabilicontatti').then((res: any) => {
                    const filteredData = res.data.filter(item => ruoliSelezionati.includes(item.Tipo));
                    const matchedData = dataExport.filter(item => {
                      return filteredData.some(resItem => resItem.Contatto === item.Cod);
                    })

                    const unifiedArray = matchedData.map(contact => {
                      const responsabili = filteredData.filter(resItem => resItem.Contatto === contact.Cod).sort((a, b) => a.Sede - b.Sede)
                      const sediResponsabili = responsabili.map(resItem => {
                        return sedi.find(sede => sede.Cod === resItem.Sede);
                      }).filter(sede => sede !== undefined);

                      return {
                        contatti: [contact],
                        responsabili: responsabili,
                        sedi: sediResponsabili
                      };
                    });

                    const addedRows = new Set();
                    unifiedArray.forEach(item => {
                      item.contatti.forEach(contatto => {
                        item.responsabili.forEach(responsabile => {
                          if (contatto.Mail && mailAziendale !== 2) {
                            const emails = contatto.Mail.split(';');
                            const rowKey = `${contatto.RagSoc}-${contatto.Ind}-${contatto.Mail}`;
                            if (!addedRows.has(rowKey)) {
                              addedRows.add(rowKey);
                              emails.forEach(email => {
                                if (email != '') {
                                  contattiSheet.addRow({
                                    RagSocContatto: contatto.RagSoc || '',
                                    Mail: email.trim(),
                                    tipo: 'AZIENDALE'
                                  });
                                }
                              });
                            }
                          }

                          if (responsabile.Mail) {
                            const emails = responsabile.Mail.split(';');
                            if (item.sedi && item.sedi.length > 0) {
                              if (responsabile.Sede === 0) {
                                emails.forEach(email => {
                                  if (email != '') {
                                    const rowKey = `${contatto.RagSoc}-${responsabile.RagSoc}-${contatto.Ind}-${email}`;
                                    if (!addedRows.has(rowKey)) {
                                      addedRows.add(rowKey);
                                      contattiSheet.addRow({
                                        RagSocContatto: contatto.RagSoc || '',
                                        RagSocRespContatto: responsabile.RagSoc || '',
                                        Mail: email.trim(),
                                        tipo: this.getTipoRuolo(responsabile.Tipo),
                                      });
                                    }
                                  }
                                });
                              } else {
                                item.sedi.forEach(sede => {
                                  emails.forEach(email => {
                                    if (email != '') {
                                      const rowKey = `${contatto.RagSoc}-${responsabile.RagSoc}-${sede.Ind}-${email}`;
                                      if (!addedRows.has(rowKey)) {
                                        addedRows.add(rowKey);
                                        contattiSheet.addRow({
                                          RagSocContatto: contatto.RagSoc || '',
                                          RagSocRespContatto: responsabile.RagSoc || '',
                                          Ind: sede.Ind ? `${sede.Ind} ${this.getDescrizioneProvincia(sede.id_provincia)}` : '',
                                          Mail: email.trim(),
                                          tipo: this.getTipoRuolo(responsabile.Tipo),
                                        });
                                      }
                                    }
                                  });
                                })
                              }
                            } else if (responsabile.Sede === 0) {
                              emails.forEach(email => {
                                if (email != '') {
                                  const rowKey = `${contatto.RagSoc}-${responsabile.RagSoc}-${contatto.Ind}-${email}`;
                                  if (!addedRows.has(rowKey)) {
                                    addedRows.add(rowKey);
                                    contattiSheet.addRow({
                                      RagSocContatto: contatto.RagSoc || '',
                                      RagSocRespContatto: responsabile.RagSoc || '',
                                      Mail: email.trim(),
                                      tipo: this.getTipoRuolo(responsabile.Tipo),
                                    });
                                  }
                                }
                              });
                            }
                          }
                        })
                      })
                    })

                    const lastRow = contattiSheet.lastRow ? contattiSheet.lastRow.number : 1;
                    contattiSheet.pageSetup.printArea = `A1:N${lastRow}`;

                    workbook.xlsx.writeBuffer().then((buffer) => {
                      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      saveAs(blob, 'contatti_anagrafica.xlsx');
                      console.log('File Excel creato con successo!');
                      this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
                      this.userComponentService.destroyOutputComponent();
                      sub.unsubscribe();

                      notify({
                        message: 'Export avvenuto con successo',
                        height: 45,
                        width: 250,
                        position: 'center center'

                      }, 'success', 3000);
                    }).catch(err => {
                      console.error('Errore durante la creazione del file Excel', err);
                    });
                  })
                })

                break;

              default:
                alert('Seleziona un opzione valida per l\'export.', 'Attenzione!');
                return;
            }
          })
        }

        if (currentOutput.name === 'return' && currentOutput.guid === guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
          this.userComponentService.destroyOutputComponent();
          sub.unsubscribe();
        }
      });
    }
  }

  getTipoRuolo(id: number): string {
    if (id == null) return ''
    const tipoRuolo = this.dataTipoRuolo.find(item => item.id === id);
    return tipoRuolo ? tipoRuolo.descrizione : '';
  }

  getDescrizioneProvincia(idProvincia: number): string {
    if (idProvincia == null) return ''
    const provincia = this.province.find(item => item.id === idProvincia);
    return provincia ? `(${provincia.sigla_automobilistica})` : '';
  }


  async onValueRegione(event: any) {

    console.log(event)

    this.listProvince = []
    this.listComune = []
    this.getApi('province?$filter=id_regione eq ' + event.value).then((x) => {
      this.listProvince = x;
      this.selectedProvincia = null;
    })

  }

  async onValueProvince(event: any) {

    this.listComune = []
    console.log('selectedProvincia', this.selectedProvincia)
    this.getApi('comuni?$filter=id_provincia eq ' + event.value).then((x) => {
      this.listComune = x;
      this.selectedComune = null;
    })
  }

}
